import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Box } from '@material-ui/core'
import RenderRoutes from 'Routes/RenderRoutes'
import { useLocation } from 'react-router'

import NotificationBanner from 'Components/SharedComponents/NotificationBanner/NotificationBanner'
import { GlobalDialog } from 'Components/Views/Dialogs/GlobalDialog'
import { SuperLoading } from 'Components/SharedComponents/Loading/SuperLoading'
import Routes from '../../Pages'
import { useStyles } from './styles'
import Chatbot from './DummyChatBot/Chatbot'

const AppRoutes = () => {
  const { isAuthenticated, isLoading, error: auth0Error } = useAuth0()
  const classes = useStyles()
  const location = useLocation().pathname
  const isPublic =
    location === '/checkout' ||
    location === '/welcome' ||
    location === '/invite'

  const isAcademyResourceView =
    location.includes('/trainings') ||
    location.includes('resources/template') ||
    location.includes('resources/article')

  const isPageWithoutNavigation =
    location.includes('account/donation/portal') ||
    location.includes('impact/stories/view') ||
    location.includes('impact/stories/edit') ||
    location.includes('impact/stories/new') ||
    location === '/fundraising/funder' ||
    location === '/welcome' ||
    location === '/invite' ||
    location === '/get-started' ||
    location === '/check-in' ||
    location === '/intake'

  const isAcademyHomePage = location === '/academy/resources'

  const isLearningTracksResource =
    location.includes('/academy/learning-tracks') &&
    location.includes('/resources/')

  const isCommunityPage = location.startsWith('/community')
  const whiteSpaceHeight = isAuthenticated ? '2em' : '5em'
  const whiteSpaceCommunityHeight = isCommunityPage ? '0' : whiteSpaceHeight
  const showWhiteSpaceBox =
    location !== '/get-started' &&
    location !== '/funder/dashboard' &&
    location !== '/check-in' &&
    location !== '/intake' &&
    !isAcademyResourceView

  useEffect(() => {
    window.HubSpotConversations?.widget.refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const mainClass = isAcademyHomePage
    ? classes.academyHomePageContent
    : classes.content

  const showChatbot = !isCommunityPage && !isLearningTracksResource

  if (isLoading) {
    return <SuperLoading withSidebar={!isPageWithoutNavigation} />
  }

  return (
    <main className={mainClass}>
      {isPublic ? (
        <Box style={{ height: 0 }} />
      ) : (
        <>
          <NotificationBanner />
          <GlobalDialog />
          {showWhiteSpaceBox && <Box height={whiteSpaceCommunityHeight} />}
          {showChatbot && <Chatbot />}
        </>
      )}
      <RenderRoutes routes={Routes} />
    </main>
  )
}

export default AppRoutes
